import Api from './../api'

export default DataLayer => DataLayer.$extend('shows', {
    getById(id) {
        return Api.shows.get({ id })
    },
})
